/**
 * 로딩 상태를 반환한다.
 * @param {*} state
 */
const isLoading = state => state.isLoading

export default { isLoading }
